export const articles = [
  {
    slug: "knife-skill",
    title: "The Quiet Power of a Sharp Knife",
    category: "Cooking Tips",
    date: "Sep 2026",
    readTime: "4 min",
    author: "Chef Eddie G",
    excerpt:
      "Before technique, before recipe, there is the blade. A sharp knife is the first honest conversation between a cook and an ingredient.",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20hands%20slicing%20fresh%20green%20herbs%20on%20a%20worn%20wooden%20board%2C%20editorial%20food%20photography%2C%20warm%20natural%20light%2C%20muted%20earthy%20palette%2C%20shallow%20depth%20of%20field&width=1200&height=800&seq=journal-knife-skill&orientation=landscape",
    body: [
      "Every kitchen I have ever respected has the same tell: a cook who stops to sharpen before they stop to think. The blade is not a tool you pick up, it is the instrument you tune.",
      "A sharp knife does not bruise. It does not tear. It lets an ingredient stay exactly what it is while you change its shape — which is, when you think about it, the whole philosophy of cooking in one movement.",
      "Start with a simple stone, a steady angle and five unhurried minutes. Learn the sound the steel makes against ceramic. Then cook something so plain that the only thing left to taste is your own attention.",
    ],
  },
  {
    slug: "sourdough-mornings",
    title: "Sourdough Mornings in a Stranger's Kitchen",
    category: "Food Stories",
    date: "Aug 2026",
    readTime: "6 min",
    author: "Chef Eddie G",
    excerpt:
      "A loaf that has been fed for eleven years, a family that has lived here for three, and the way bread quietly makes strangers into neighbours.",
    image:
      "https://readdy.ai/api/search-image?query=rustic%20sourdough%20loaf%20cooling%20on%20a%20rack%20with%20flour%20dust%20in%20warm%20morning%20light%2C%20editorial%20food%20photography%2C%20muted%20earthy%20palette%2C%2035mm%20film%20grain&width=900&height=1200&seq=journal-sourdough&orientation=portrait",
    body: [
      "The starter had a name and a birthday. Eleven years old, fed twice a day, kept in a jar that had clearly outlived several apartments. I was offered a slice before I was offered a seat.",
      "Bread is the slowest invitation there is. It asks for hours you cannot get back, and in return it hands you a room full of people who suddenly have nowhere to be.",
      "I left that kitchen with flour on my sleeve and a recipe I will probably never reproduce exactly. That, I think, was the point.",
    ],
  },
  {
    slug: "ember-cooking",
    title: "Cooking Without a Thermostat",
    category: "Cooking Tips",
    date: "Aug 2026",
    readTime: "5 min",
    author: "Chef Eddie G",
    excerpt:
      "Embers ask you to cook with your eyes and your hands. It is the oldest method and still the one that teaches the most.",
    image:
      "https://readdy.ai/api/search-image?query=glowing%20embers%20and%20flames%20under%20a%20grill%20at%20night%20with%20smoke%20rising%2C%20documentary%20editorial%20photography%2C%20warm%20orange%20glow%2C%20muted%20atmosphere%2C%2035mm%20film%20grain&width=1400&height=900&seq=journal-ember-cooking&orientation=landscape",
    body: [
      "A dial tells you a number. An ember tells you a mood. Cooking over live fire means reading colour, listening for the hiss, and moving with the heat instead of against it.",
      "Build two zones and let them disagree. One side to char and one to rest. The meal lives in the space between them.",
      "By the end of the night you will trust your hand more than any thermometer, which is exactly how every cook worth their salt learned in the first place.",
    ],
  },
  {
    slug: "spice-route",
    title: "Notes From the Spice Route",
    category: "Travel Discoveries",
    date: "Jul 2026",
    readTime: "7 min",
    author: "Chef Eddie G",
    excerpt:
      "A market where every stall had an opinion, and a lesson in how a single pinch can change the memory of an entire trip.",
    image:
      "https://readdy.ai/api/search-image?query=colorful%20spice%20market%20stall%20with%20mounds%20of%20powdered%20spices%20in%20open%20sacks%2C%20documentary%20editorial%20travel%20photography%2C%20warm%20muted%20palette%2C%2035mm%20film%20grain&width=900&height=1200&seq=journal-spice-route&orientation=portrait",
    body: [
      "The best stalls never sell you what you asked for. They smell the air, look at your hands, and hand you something you did not know you were looking for.",
      "I bought too much, of course. Saffron wrapped in newsprint, a brick of tamarind, a jar of something I still cannot name. My suitcase smelled like a market for a month.",
      "Cooking with them back home, I stopped trying to recreate the trip and started letting the ingredients tell me where they wanted to go.",
    ],
  },
  {
    slug: "harbour-table",
    title: "The Table at the End of the Harbour",
    category: "Food Stories",
    date: "Jun 2026",
    readTime: "5 min",
    author: "Chef Eddie G",
    excerpt:
      "Twelve strangers, one boat, and a dinner that started when the nets came in and ended well after the lanterns did.",
    image:
      "https://readdy.ai/api/search-image?query=small%20harbour%20with%20wooden%20boats%20at%20dusk%20and%20warm%20lantern%20light%20on%20the%20water%2C%20documentary%20editorial%20photography%2C%20muted%20earthy%20palette%2C%2035mm%20film%20grain&width=1400&height=900&seq=journal-harbour-table&orientation=landscape",
    body: [
      "Nobody had planned a dinner. There was a boat, a catch, and a group of people who all happened to be hungry at the same time. Sometimes that is the whole recipe.",
      "We grilled on the dock because there was nowhere else to sit. By the time the lanterns came out, nobody remembered who had arrived with whom.",
      "Good food does that. It erases the edges of the room until everyone is just a person with a plate and a story.",
    ],
  },
  {
    slug: "grower-portrait",
    title: "The Grower Who Reads the Weather Like a Menu",
    category: "Behind the Scenes",
    date: "May 2026",
    readTime: "6 min",
    author: "Chef Eddie G",
    excerpt:
      "A morning with a farmer who plans dinner a season in advance — and the reason locavore starts in the soil, not the pan.",
    image:
      "https://readdy.ai/api/search-image?query=wooden%20crates%20of%20freshly%20picked%20vegetables%20resting%20in%20a%20field%20at%20dawn%20with%20dew%20and%20soft%20mist%2C%20documentary%20editorial%20photography%2C%20warm%20natural%20light%2C%20muted%20earthy%20palette%2C%2035mm%20film%20grain&width=1100&height=1100&seq=journal-grower-harvest&orientation=squarish&nocache=true",
    body: [
      "He walked the rows the way a chef walks a line — checking, tasting, correcting. A week of rain meant a change of plan, and a change of plan meant a different dinner entirely.",
      "That is the honest version of seasonal cooking. It is not a style you choose. It is a schedule the land hands you and dares you to keep up with.",
      "I went looking for ingredients and came back with a calendar. Best trade I have made in years.",
    ],
  },
  {
    slug: "pasta-by-hand",
    title: "Pasta, By Hand, With Someone's Grandmother",
    category: "Food Stories",
    date: "Apr 2026",
    readTime: "5 min",
    author: "Chef Eddie G",
    excerpt:
      "No recipe card, no measurements — just flour, eggs, and a pair of hands that have made this shape ten thousand times.",
    image:
      "https://readdy.ai/api/search-image?query=hands%20shaping%20fresh%20pasta%20on%20a%20floured%20wooden%20table%20with%20warm%20window%20light%2C%20editorial%20food%20photography%2C%20muted%20earthy%20palette%2C%2035mm%20film%20grain&width=900&height=1200&seq=journal-pasta-hand&orientation=portrait",
    body: [
      "She measured nothing and made no mistakes. When I asked for the recipe she laughed, held up her hands, and said the recipe was in there.",
      "So I watched instead — the wrist, the fold, the exact moment the dough stopped arguing and started obeying. I wrote none of it down and remember all of it.",
      "Some skills survive because someone was patient enough to teach them to a stranger who asked.",
    ],
  },
  {
    slug: "cellar-light",
    title: "In the Cellar, Where Time Is an Ingredient",
    category: "Behind the Scenes",
    date: "Mar 2026",
    readTime: "6 min",
    author: "Chef Eddie G",
    excerpt:
      "A walk through barrels and dust and patience — and what old cellars teach us about cooking the things that cannot be rushed.",
    image:
      "https://readdy.ai/api/search-image?query=old%20wine%20cellar%20with%20rows%20of%20oak%20barrels%20and%20a%20single%20shaft%20of%20warm%20light%2C%20documentary%20editorial%20photography%2C%20muted%20earthy%20palette%2C%2035mm%20film%20grain&width=1400&height=900&seq=journal-cellar-light&orientation=landscape",
    body: [
      "Down here nothing hurries. The barrels simply wait, and waiting turns juice into something with a memory.",
      "It made me think about every dish I have ever tried to rush. Stock, braise, ferment, cure — the good ones all share the same secret, and the secret is time.",
      "I left the cellar promising to cook slower. I have kept that promise about half the time, which is probably a respectable score.",
    ],
  },
];